// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js';

import 'owl.carousel';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import corona from './routes/corona';
import singleAccommodation from './routes/singleAccommodation';
import singleSkiArea from './routes/singleSkiArea';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Corona Page
  corona,
  // Single Accommodation page
  singleAccommodation,
  singleSkiArea,
});

// Load Events
jQuery(document).ready(() => {
  routes.loadEvents();
});



// WEBPACK FOOTER //
// ./scripts/main.js